/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, August 2022
 * @format
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import PopupHeader from '../../../../components/PopupHeader';
import strings from '../../../../globalization';
import classes from './CaptureSeatName.module.css';

const CaptureSeatName = ({ onClose, onUpdateSeatName }) => {
  const [seatName, setSeatName] = useState('');

  const onSubmit = () => {
    onUpdateSeatName && onUpdateSeatName(seatName);
  };

  return (
    <div className={classes.container}>
      <PopupHeader
        title={strings.updateSeatName}
        onClose={onClose}
        containerStyle={classes.headerStyle}
        closeIconStyle={classes.closeIcon}
        titleStyle={classes.titleStyle} />
      <div className={classes.contentWrapper}>
        <div className={classes.inputWrapper}>
          <label className={classes.label}>{strings.seatName}</label>
          <input
            type={'text'}
            value={seatName}
            onChange={event => setSeatName(event.target.value)}
            className={classes.input}
          />
        </div>
        <Button className={classes.button} onClick={onSubmit} disabled={seatName.trim() === ''}>
          <span className={classes.buttonText}>{strings.update}</span>
        </Button>
      </div>
    </div>
  );
};

export default CaptureSeatName;

CaptureSeatName.propTypes = {
  onClose: PropTypes.func,
  onUpdateSeatName: PropTypes.func,
};

CaptureSeatName.defaultProps = {
  onClose: () => { },
  onUpdateSeatName: () => { },
};
